import { useState } from "react";
import { brandDomain } from "@/lib/brand-domains";

const LOGO_TOKEN = import.meta.env["VITE_LOVABLE_CONNECTOR_LOGO_DEV_API_KEY"] as
  | string
  | undefined;

interface BrandLogoProps {
  makeSlug: string;
  makeName: string;
  /** Rendered pixel size (square). */
  size?: number;
  className?: string;
}

/**
 * Manufacturer logo via Logo.dev, with a typographic monogram fallback so the
 * layout never collapses when a brand has no logo or the request is blocked.
 */
export function BrandLogo({ makeSlug, makeName, size = 32, className = "" }: BrandLogoProps) {
  const [failed, setFailed] = useState(false);
  const domain = brandDomain(makeSlug);
  const showImage = Boolean(domain && LOGO_TOKEN) && !failed;

  return (
    <span
      className={className ? `brand-logo ${className}` : "brand-logo"}
      {...(size === 32 ? {} : { style: { width: size, height: size } })}
    >
      {showImage ? (
        <img
          src={`https://img.logo.dev/${domain}?token=${LOGO_TOKEN}&size=${size * 2}&format=webp`}
          alt={`${makeName} logo`}
          width={size}
          height={size}
          loading="lazy"
          decoding="async"
          className="brand-logo-img"
          onError={() => setFailed(true)}
        />
      ) : (
        <span
          aria-hidden="true"
          className="font-heading font-bold text-secondary-foreground"
          style={{ fontSize: Math.round(size * 0.42) }}
        >
          {makeName.slice(0, 2).toUpperCase()}
        </span>
      )}
    </span>
  );
}